/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Mzsphilosophie14Inputs */

const en__field_enum_mzsphilosophie14 = /** @type {(inputs: _Field_Enum_Mzsphilosophie14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`philosophy and history`)
};

const de__field_enum_mzsphilosophie14 = /** @type {(inputs: _Field_Enum_Mzsphilosophie14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Philosophie und Geschichtswissenschaften`)
};

/**
* | output |
* | --- |
* | "philosophy and history" |
*
* @param {_Field_Enum_Mzsphilosophie14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_mzsphilosophie14 = /** @type {((inputs?: _Field_Enum_Mzsphilosophie14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Mzsphilosophie14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_mzsphilosophie14(inputs)
	return de__field_enum_mzsphilosophie14(inputs)
});
export { _field_enum_mzsphilosophie14 as "_field_enum_MZSPHILOSOPHIE" }